<template>
  <article class="dashboard-card preika-insight-card preika-action-center">
    <div class="preika-insight-heading">
      <div>
        <p class="preika-insight-heading__eyebrow">TODAY'S ACTIONS</p>
        <h2>今日のアクション</h2>
        <p class="preika-insight-heading__description">
          優先度の高い打刻・提出・承認をまとめています。
        </p>
      </div>
      <span class="preika-insight-count">
        {{ items.length }}件
      </span>
    </div>

    <div v-if="loading" class="preika-insight-loading">
      <span class="preika-insight-loading__spinner"></span>
      対応事項を確認中
    </div>

    <div v-else-if="error" class="preika-insight-error" role="alert">
      <div>
        <strong>アクションを取得できませんでした</strong>
        <small>既存の打刻・提出機能はそのままご利用いただけます。</small>
      </div>
      <button type="button" @click="$emit('retry')">再取得</button>
    </div>

    <div v-else-if="items.length" class="preika-action-list">
      <router-link
        v-for="item in items"
        :key="item.key"
        :to="destination(item)"
        class="preika-action-item"
        :class="'preika-action-item--' + priorityTone(item.priority)"
      >
        <span class="preika-action-item__icon">
          <CIcon :name="actionIcon(item.kind)"/>
        </span>
        <span class="preika-action-item__content">
          <span class="preika-action-item__topline">
            <strong>{{ item.title }}</strong>
            <small v-if="item.meta">{{ item.meta }}</small>
          </span>
          <span class="preika-action-item__description">
            {{ item.description }}
          </span>
        </span>
        <span v-if="item.count" class="preika-action-item__count">
          {{ item.count }}
        </span>
        <CIcon name="cil-chevron-right" class="preika-action-item__arrow"/>
      </router-link>
    </div>

    <div v-else class="preika-insight-empty">
      <span class="preika-insight-empty__icon">
        <CIcon name="cil-check-circle"/>
      </span>
      <div>
        <strong>現在、優先対応はありません</strong>
        <p>打刻・月次提出・承認の状態は整っています。</p>
      </div>
    </div>
  </article>
</template>

<script>
import { routeWithYearMonth } from '../../utils/askedYearMonth'

export default {
  name: 'DashboardActionCenter',

  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    /**
     * 行を押した先。**その行の月で開く**（2026-10-08、監査）。
     *
     * 行き先の画面（勤務表・業務報告・経費精算・通勤費精算）は、開いたときの月を自分で決める
     * （毎月9日までは前月、10日からは今月）。「8月分」の差戻しの行を押しても、月を渡して
     * いなかったので、別の月が開いていた。サーバが行に付けた月（yearMonth）を行き先へ付ける。
     * 年月を取らない画面（自分の申請一覧・承認待ちの申請・休暇申請詳細）の行と、月を持たない行
     * （打刻）は、今までどおりの行き先のまま。
     */
    destination (item) {
      return routeWithYearMonth(item.route || '/dashboard', item.yearMonth)
    },

    priorityTone (priority) {
      return ({
        CRITICAL: 'critical',
        HIGH: 'high',
        NORMAL: 'normal'
      })[priority] || 'normal'
    },

    actionIcon (kind) {
      return ({
        ATTENDANCE: 'cil-clock',
        SUBMISSION: 'cil-paper-plane',
        APPROVAL: 'cil-check-circle',
        FORECAST: 'cil-chart-pie'
      })[kind] || 'cil-bell'
    }
  }
}
</script>
